var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPellSocialDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_203_1701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3302 2.42804C18.7528 1.70663 17.0878 1.19476 15.3778 0.905071C15.1458 1.32085 14.933 1.75632 14.7455 2.1946C13.8356 2.05726 12.9173 1.98835 11.9972 1.98788C11.0789 1.98788 10.1559 2.05773 9.24844 2.19273C9.06328 1.75538 8.84812 1.32179 8.61469 0.904602C6.90703 1.1957 5.23781 1.71085 3.66094 2.43085C0.526406 7.0682 -0.322969 11.5888 0.101719 16.0457C1.93688 17.4013 3.99141 18.4326 6.17484 19.094C6.66469 18.433 7.10344 17.729 7.47563 16.9968C6.765 16.7319 6.07922 16.4048 5.42625 16.019C5.59828 15.8943 5.76609 15.7659 5.92828 15.6416C7.82672 16.5332 9.90094 16.9982 11.9991 16.9982C14.0972 16.9982 16.1719 16.5332 18.0703 15.6416C18.2344 15.7757 18.4027 15.9041 18.5723 16.019C17.918 16.4057 17.2313 16.7338 16.5192 16.9996C16.8928 17.7337 17.3283 18.4344 17.82 19.0949C20.0058 18.4354 22.0617 17.4046 23.8973 16.0471H23.8969C24.3952 10.8791 23.0456 6.39976 20.3292 2.42804H20.3302ZM8.01281 13.3049C6.82922 13.3049 5.85141 12.231 5.85141 10.9096C5.85141 9.58819 6.795 8.50491 8.00906 8.50491C9.22313 8.50491 10.193 9.58866 10.1723 10.9096C10.1517 12.231 9.21891 13.3049 8.01281 13.3049ZM15.9862 13.3049C14.8008 13.3049 13.8267 12.231 13.8267 10.9096C13.8267 9.58819 14.7708 8.50491 15.9862 8.50491C17.2017 8.50491 18.1645 9.58866 18.1439 10.9096C18.1233 12.231 17.1923 13.3049 15.9862 13.3049Z",
    fill: "#C3C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_1701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.1898,
    fill: "white",
    transform: "translate(0 0.90509)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPellSocialDiscord);
export default __webpack_public_path__ + "static/media/pell_social_discord.f37583c2db574723a137361d762c4115.svg";
export { ForwardRef as ReactComponent };